<mat-sidenav-container [hasBackdrop]="responsive.isHandset()">
  <!-- SideNav: rail on tablet/desktop (mode="side"); slide-over drawer on phones (mode="over"). -->
  <mat-sidenav
    [ngClass]="!responsive.isHandset() && !isSidenavOpen ? 'closed-mat-sidenav' : 'opened-mat-sidenav'"
    [mode]="responsive.isHandset() ? 'over' : 'side'"
    [opened]="responsive.isHandset() ? isSidenavOpen : true"
    (openedChange)="onSidenavOpenedChange($event)"
    fixedInViewport="true"
  >
    <app-side-nav [isSidenavOpen]="responsive.isHandset() ? true : isSidenavOpen" (sidenavToggle)="toggleSidenav()"></app-side-nav>
  </mat-sidenav>

  <!-- Right section: Toolbar + Page Content -->
  <mat-sidenav-content class="main-container" [ngClass]="{ 'sidenav-open': isSidenavOpen }">
    <!-- Toolbar -->
    <mat-toolbar
      class="custom-horizontal-toolbar display-inline-space-between"
      [ngClass]="{ 'width-handset': responsive.isHandset(), 'width-desktop': !responsive.isHandset() }"
    >
      <div class="display-inline-start">
        @if (responsive.isHandset()) {
          <button
            aria-label="Toggle navigation menu"
            type="button"
            class="menu-toggle-button"
            [disabled]="passwordExpiryService.hasPasswordExpired()"
            (click)="toggleSidenav()"
            mat-icon-button
          >
            <mat-icon>menu</mat-icon>
          </button>
        }
        <div
          tabindex="0"
          aria-label="Go to AsseTotal home"
          role="button"
          class="application-container"
          (click)="redirectToHomePage()"
          (keydown.enter)="redirectToHomePage()"
          (keydown.space)="redirectToHomePage()"
        >
          <span class="application-logo-chip">
            <img alt="Logo" class="application-logo" [src]="erpLogoUrl" />
          </span>
          <span class="application-title">AsseTotal</span>
        </div>
      </div>

      @if (!responsive.isHandset()) {
        <div class="login-entity-name">{{ userInfo?.kiClient?.name }}</div>
      }

      <div class="display-inline-end">
        <!-- Notification -->
        <button
          type="button"
          class="notification-button"
          [disabled]="passwordExpiryService.hasPasswordExpired()"
          [routerLink]="['/notifications']"
          mat-icon-button
          matTooltip="{{ 'COMMON.NOTIFICATIONS' | translate }}"
        >
          <mat-icon class="notification-icon">notifications</mat-icon>
          @if (unreadNotificationCount > 0) {
            <span class="notification-count">{{ notificationBadgeLabel }}</span>
          }
        </button>

        <!-- Language Selector -->
        <button aria-label="Select language" type="button" class="toolbar-menu-button language-button" [matMenuTriggerFor]="langMenu" mat-button>
          <mat-icon class="language-icon">translate</mat-icon>
          @if (!responsive.isHandset()) {
            <span class="language-label">{{ getCurrentLanguageLabel() }}</span>
          }
          @if (!responsive.isHandset()) {
            <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
          }
        </button>
        <mat-menu #langMenu="matMenu" class="language-menu">
          @for (language of languages(); track language.id) {
            <button
              type="button"
              class="language-menu-item"
              [ngClass]="{ 'selected-lang': languageControl.value === language.code }"
              (click)="languageControl.setValue(language.code!)"
              mat-menu-item
            >
              <span class="language-item-label">
                {{ language.name }}
                @if (languageControl.value === language.code) {
                  <mat-icon>check</mat-icon>
                }
              </span>
            </button>
          }
        </mat-menu>

        <!-- User menu -->
        <button type="button" class="toolbar-menu-button user-button" [matMenuTriggerFor]="menu" mat-button>
          @if (userInfo?.profilePic) {
            <img alt="Profile" class="profile-pic" [src]="userInfo?.profilePic" />
          } @else {
            <mat-icon class="profile-icon">account_circle</mat-icon>
          }
          @if (!responsive.isHandset()) {
            <span class="username"
              >{{ userName }}
              <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
            </span>
          } @else {
            <span class="username">
              <mat-icon class="dropdown-icon">arrow_drop_down</mat-icon>
            </span>
          }
        </button>
        <mat-menu #menu="matMenu">
          @if (!isApplicationSupport) {
            <button type="button" [disabled]="passwordExpiryService.hasPasswordExpired()" (click)="viewProfile()" mat-menu-item>
              <mat-icon>person</mat-icon>
              <span>{{ 'COMMON.PROFILE' | translate }}</span>
            </button>
            <button type="button" (click)="changePassword()" mat-menu-item>
              <mat-icon>password</mat-icon>
              <span>{{ 'COMMON.CHANGE_PASSWORD' | translate }}</span>
            </button>
          }
          <button type="button" (click)="onLogout()" mat-menu-item>
            <mat-icon>logout</mat-icon>
            <span>{{ 'COMMON.LOGOUT' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    </mat-toolbar>

    <!-- Page Content -->
    <div class="page-content">
      <!-- <app-breadcrumb></app-breadcrumb> -->
      <router-outlet></router-outlet>
    </div>

    <div>
      <mat-toolbar class="custom-footer">
        <div class="featured-by-container">
          <div class="marquee-content">
            {{ 'COMMON.POWERED_BY_PREFIX' | translate }}
            <span
              tabindex="0"
              class="codatron-text"
              (click)="redirectToCodatron()"
              (keydown.enter)="redirectToCodatron()"
              (keydown.space)="redirectToCodatron()"
              >{{ 'COMMON.CODATRON' | translate }}</span
            >
            {{ 'COMMON.POWERED_BY_SUFFIX' | translate }}
            <img
              alt="Logo"
              class="codatron-logo"
              [src]="codatronLogoUrl"
              (click)="redirectToCodatron()"
              (keydown.enter)="redirectToCodatron()"
              (keydown.space)="redirectToCodatron()"
            />
          </div>
        </div>
      </mat-toolbar>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
